import React from 'react';

type Props = {
  icon: Object,
  content: string,
  subContent: string,
};

const NoContentPlaceHolder = (props: Props) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', color: '#A3A3A3' }}>
      <div>
        <img src={props.icon} height={'131px'} width={'131px'} alt={''} />
      </div>
      <div style={{ marginTop: '32px', fontWeight: '500', fontSize: '24px' }}>{props.content}</div>
      <div style={{ marginTop: '12px', fontSize: '16px' }}>{props.subContent}</div>
    </div>
  );
};

export default NoContentPlaceHolder;
